import {PENDING_WRAPS} from '../actionTypes'
import {reducerFactory} from '../../lib/asyncUtil'

export default reducerFactory(PENDING_WRAPS)
